import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AsyncSubject, Observable, of } from 'rxjs';

import { AccountService } from '../core/account';
import { AccountRouteParams, SiteCreateProgressRouteParams } from '../core/routeparams';

@Injectable()
export class AccountIdLoggedInCanActivate {
  subject: AsyncSubject<boolean> = new AsyncSubject<boolean>();

  constructor(private accountService: AccountService) {}

  public static buildLoginUrl(accountId: string, nextUrl: string): string {
    let loginUrl = '/vdc-session/transfer/' + accountId;
    if (nextUrl) {
      loginUrl = loginUrl.concat('?nextUrl=' + encodeURIComponent(nextUrl));
    }
    return loginUrl;
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    let accountId = (route.params as AccountRouteParams).accountGroupId;
    if (accountId === '' || accountId === undefined || accountId === null) {
      accountId = (route.params as SiteCreateProgressRouteParams).accountId;
    }

    const nextUrlParam = 'nextUrl';
    let nextUrl = route.queryParams[nextUrlParam];
    if (nextUrl === '' || nextUrl === undefined || nextUrl === null) {
      nextUrl = location.href;
    }

    this.accountService.fetch(accountId);
    this.accountService.error().subscribe((err) => {
      if (err.statusInt === 403) {
        window.location.href = `/app-insufficient-permission/${accountId}`;
      } else {
        window.location.href = AccountIdLoggedInCanActivate.buildLoginUrl(accountId, nextUrl);
      }
      return of(false);
    });
    this.accountService.accountAuthResult().subscribe(
      (pingResult) => {
        if (pingResult) {
          this.subject.next(true);
          this.subject.complete();
        } else {
          console.log('account endpoint returned falsy pingResult:', pingResult);
          window.location.href = AccountIdLoggedInCanActivate.buildLoginUrl(accountId, nextUrl);
        }
      },
      (err) => {
        console.log('error while pinging the account endpoint:', err);
        window.location.href = AccountIdLoggedInCanActivate.buildLoginUrl(accountId, nextUrl);
      },
    );
    return this.subject;
  }
}
